import { FETCH_DEVELOPER_MENU_SETTINGS_SUCCESS, UPDATE_DEVELOPER_MENU_SETTINGS, FETCH_DEVELOPER_MENU_SETTINGS, SAVE_DEVELOPER_MENU_SETTINGS,
  SAVE_DEVELOPER_MENU_SETTINGS_SUCCESS, SAVE_DEVELOPER_MENU_SETTINGS_ERROR, CHANGE_DEVELOPER_MENU_SETTINGS } from "constants/ActionTypes";
import { CustomAction, DeveloperMenuState } from "model/state";
import { DeveloperMenuPayload } from "actions";

const initialState: DeveloperMenuState = {
  developerMenuSettings: {
    isSubmitting: false,
    settings: null,
  }
};

function settingsReducer(state: DeveloperMenuState | undefined = initialState, action: CustomAction<DeveloperMenuPayload>) {
  switch (action.type) {
    case FETCH_DEVELOPER_MENU_SETTINGS_SUCCESS: {
      return {
        ...state,
        developerMenuSettings: {
          ...state.developerMenuSettings,
          settings: action.payload?.settings || null
        }
      }
    }

    case FETCH_DEVELOPER_MENU_SETTINGS: {
      return {
        ...state,
        developerMenuSettings: {
          ...state.developerMenuSettings,
          settings: null,
        }
      }
    }

    case UPDATE_DEVELOPER_MENU_SETTINGS: {
      return {
        ...state,
        developerMenuSettings: {
          ...state.developerMenuSettings,
          settings: action.payload?.settings || null
        }
      }
    }

    case CHANGE_DEVELOPER_MENU_SETTINGS: {
      return {
        ...state,
        developerMenuSettings: {
          ...state.developerMenuSettings,
          settings: action.payload?.settings || null
        }
      }
    }

    case SAVE_DEVELOPER_MENU_SETTINGS: {
      return {
        ...state,
        developerMenuSettings: {
          ...state.developerMenuSettings,
          isSubmitting: true,
        }
      }
    }

    case SAVE_DEVELOPER_MENU_SETTINGS_SUCCESS:
    case SAVE_DEVELOPER_MENU_SETTINGS_ERROR:
      return {
        ...state,
        developerMenuSettings: {
          ...state.developerMenuSettings,
          isSubmitting: false,
        }
      }

    default:
      return state
  }
}

export default settingsReducer;
